import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setAuth } from '../../store/slices/authSlice';
import { useLogin } from './auth.hooks';
import { useNavigate } from 'react-router-dom';
import {
  Container, TextField, Button, Typography, Paper,
  FormControl, FormControlLabel, Radio, RadioGroup,
  IconButton,
  InputAdornment
} from '@mui/material';

import { showAlert } from '../../store/slices/alertSlice';
import { constants } from '../../constants';
import logo from '../../assets/images/logo.jpg'; // Adjust the path as necessary
import { Visibility, VisibilityOff } from '@mui/icons-material';
export default function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [usertype, setUsertype] = useState(constants.ADMIN); // default is admin

  const [showPassword, setShowPassword] = useState(false);
  const { mutate, isPending, error } = useLogin();
  const handleSubmit = (e) => {
    e.preventDefault();
    mutate(
      { username, password, usertype },
      {
          onSuccess: (data) => {
          dispatch(setAuth({
            usertype, // "admin" or "van"
            userid: data[usertype].id,
            value: data.token,
            name:data[usertype].username
          }));
          navigate('/');
        },
        onError: (err) => {
          dispatch(showAlert({
            severity: constants.ERROR,
            title: 'Login failed: ' + (err.message || 'Unknown error'),
          }));
        },
      }
    );
  };

  return (
    <Container maxWidth="xs">
      <Paper elevation={3} sx={{ mt: 8, p: 4 }}>
   <div className='logo-container'>
          <img
            src={logo}
            alt="Logo"
            className='logo-image'
          />
        </div>

        <form onSubmit={handleSubmit}>
        <FormControl component="fieldset" margin="normal">

  <RadioGroup
    row
              value={usertype}
              onChange={(e) => setUsertype(e.target.value)}
            >
    <FormControlLabel value={constants.ADMIN} control={<Radio />} label="Admin" />
    <FormControlLabel value={constants.VAN} control={<Radio />} label="Van" />
    <FormControlLabel value={constants.WHOLESALEUSER} control={<Radio />} label="Wholesale" />
  </RadioGroup>
          </FormControl>
          <TextField
            label="Username"
            fullWidth
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <TextField
            label="Password"
  type={showPassword ? 'text' : 'password'}
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <IconButton
          onClick={() => setShowPassword((prev) => !prev)}
          edge="end"
        >
          {showPassword ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </InputAdornment>
    ),
  }}
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ mt: 2 }}
            disabled={isPending}
          >
            {isPending ? 'Logging in...' : 'Login'}
          </Button>
        </form>
      </Paper>
    </Container>
  );
}
